import styled from "styled-components";

import LoginForm from "../features/authentication/LoginForm";
import Logo from "../ui/Logo";
import Heading from "../ui/Heading";

const LoginLayout = styled.main`
  min-height: 100vh;
  display: grid;
  grid-template-columns: 48rem;
  align-content: center;
  justify-content: center;
  gap: 3.2rem;
  background-color: var(--color-grey-50);

  @media (max-width: 480px) {
    grid-template-columns: none;
    justify-content: normal;
  }
`;

function Login() {
  return <LoginLayout>
    <Logo />
    <Heading as="h4">Entrar na sua conta</Heading>
    <LoginForm />
  </LoginLayout>
}

export default Login;
